import { el } from 'redom';

class PageResultRow {

  constructor() {

    this.data = null;

    this.pageIcon = el('.page-icon');
    this.pageName = el('.page-name');
    this.pagePath = el('.page-path');

    this.textContainer = el('.page-text-container', [
      this.pageName,
      this.pagePath
    ]);

    this.el = el('.page-result-row', [
      this.pageIcon,
      this.textContainer
    ]);

  }

  update(result) {

    this.data = result.data;

    this.pageName.textContent = this.data.name || '';
    this.pagePath.textContent = this.data.path || '';

  }

}

export default PageResultRow;